export const sizeData = [
    {
      code: ".img- * (70/80/90/100)",
      text: "You can change the size of avatar using ",
    },
    {
      text: " class",
    },
  ];
  
  export const sizeImages = [
    {
      className: "img-90",
      src: "4.jpg",
      size: 90,
    },
    {
      className: "img-80",
      src: "7.jpg",
      size: 80,
    },
    {
      className: "img-70",
      src: "11.jpg",
      size: 70,
    },
  ];
  
  export const statusData = [
    {
      code: " .status-* (online/offline/dnd) ",
      text: "Using ",
    },
    {
      text: " class you can set the status of avatar.",
    },
  ];
  
  export const statusIndicators = [
    {
      className: "img-90",
      src: "16.jpg",
      size: 90,
      color: "dnd",
    },
    {
      className: "img-80",
      src: "7.jpg",
      size: 80,
      color: "offline",
    },
    {
      className: "img-70",
      src: "3.jpg",
      size: 70,
      color: "online",
    },
  ];
  
  export const shapeData = [
    {
      code: " .b-r-* (8/30/35/25)",
      text: "Using the",
    },
    {
      text: " class you can set the shapes of avatar.",
    },
  ];
  
  export const shape = [
    {
      className: "img-90 b-r-30",
      src: "16.jpg",
    },
    {
      className: "img-80 b-r-30",
      src: "3.jpg",
    },
    {
      className: "img-70 rounded-circle",
      src: "11.jpg",
    },
  ];
  
  export const ratioData = [
    {
      code: ".ratio",
      text: "Give the shape to avatar using ",
    },
    {
      code: " img-* (50/70/80/90/100) ",
      text: " and ",
    },
    {
      text: " class.",
    },
  ];
  
  export const ratios = [
    {
      className: "img-90",
      src: "avtar/4.jpg",
      size: 90,
    },
    {
      className: "img-80",
      src: "user/1.jpg",
      size: 80,
    },
    {
      className: "img-70",
      src: "avtar/16.jpg",
      size: 70,
    },
    {
      className: "img-50",
      src: "avtar/7.jpg",
      size: 60,
    },
  ];
  
  export const groupingData = [
    {
      code: ".img-* (40/50/60/80/100) ",
      text: "You can set the group of avatars like ",
    },
    {
      code: ".b-r-* (8/30/35).",
      text: "and ",
    },
  ];
  
  export const groupingImageOne = [
    {
      className: "img-80 b-r-30",
      src: "16.jpg",
    },
    {
      className: "img-50 b-r-35",
      src: "3.jpg",
    },
  ];
  
  export const groupingImageTwo = [
    {
      className1: "b-r-8 img-80",
      src: "user/1.jpg",
      size: 76,
    },
    {
      className2: "img-60 rounded-circle",
      src: "avtar/16.jpg",
      size: 56,
    },
  ];
  
  export const groupingImageThird = ["5.jpg", "1.jpg"];